/**
 * Dispatch a custom event when finance is modified by the customer
 *
 * @param {bool} isModified
 */
export default function(isModified = false) {
    const event = new CustomEvent("new_finance_modified", {
        detail: {
            modified: isModified,
        }
    });
    window.dispatchEvent(event);
}